import React, {
    Component
} from 'react';
import * as Config from '../config/Config';
import * as User from '../helpers/User';
import * as Common from '../helpers/Common';
import Pdfview from '../components/Pdfview';
import Flowplayer from '../components/Flowplayer';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getLearningRoom} from '../actions/learningRoomAction';
// import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
//import Previous_Next from '../components/Previous_Next';
const $ = window.$;

class Anouncement extends Component {
    constructor(props) {
        super(props);
        this.compeletestatus = "";
        this.state = {
            anouncet: [],
            anouncesorting: [],
            learner_id : '',
            learningroom_id:''
        };
    }
    getAnnouncement(id, learner_id) {
        Common.reactLoader("show", "Please wait...");
        fetch(Config.domainUrl + 'anouncement/getanouncement', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify({
                a_id: id,
                learner_id:learner_id
            })
        }).then((response) => response.json()).then((responseJson) => {
            this.setState({
                anouncet: responseJson.allvalues,
                anouncesorting: responseJson.sorting,
            });
            setTimeout(() => {
                Common.contentResizeLoad();
                Common.showSmallLeftMenu();
                Common.contentResizeLoad();
                Common.reactLoader("hide");
            }, 2000);
        });
    }
    componentDidMount() {
        const { data } = this.props;
        this.state.learner_id=data.learner_id;
        this.state.learningroom_id=data.learning_room_id;
        this.compeletestatus = data.status;
        this.getAnnouncement(data.id, data.learner_id); 
        setTimeout(() => {
            $('audio').on("play", function(me) {
                $('audio').each(function(i, e) {
                    if (e !== me.currentTarget) {
                        this.pause();
                    }
                });
            });
        }, 500)
    }
    componentWillReceiveProps(nextProps) {
        const { data } = nextProps;
        this.compeletestatus = data.status;

        this.getAnnouncement(data.id, data.learner_id);
    }
    pdf_frame(pdf_files) {
        let styled = {
            width: '100%',
            padding: '15px 1.9%',
            minHeight: '500px'
        }
        return (<div key="1" className="border-box">
                <div className="title-box">
                    <div className="" title=""></div>
                    <h2>PDF Annoncement</h2>
                </div>
                <iframe id="announcementpdf" className="announcement" src={Config.rootDomainUrl+'admin/announcement_pdf_files/'+pdf_files} style={styled}>
                </iframe>
            </div>);
    }
    video_frame(video_files, text) {

        const { data } = this.props;

        let trackData={

            compseq_id: data.compseq_id,
            lroom_id: data.learning_room_id,
            divider_id: data.divider_id,
            learner_id: data.learner_id,        
            dlr_id: data.dlr_id,
            compo_type:data.compo_type
        };
        
        let v_file_extension=video_files.split(".");
        let playlist='';
        
        if(v_file_extension[1]=='mp4')
        {
                playlist={
                share:false,
                ratio: 9/16,
                clip:{
                sources: [
                        {
                            type: "video/mp4",
                            src: Config.rootDomainUrl + 'admin/announcement_video_files/' + video_files
                        }
                    ]
                }
            };
        }
        else if(v_file_extension[1]=='m3u8')
        {
            playlist={
                share:false,
                splash: true,
                ratio: 9/16,

                //playlist: [

                    clip:{
                    title: "",
                    hlsjs: {
                        // enable subtitle display
                        subtitles: true,
                        // enable audio ABR
                        audioABR: true
                    },
                    // template based vod quality selector plugin configuration
                    vodQualities: {
                        template: "//edge.flowplayer.org/functional-{q}.{ext}",
                        qualities: [
                        "160p",
                        { label: "260p", src: "//edge.flowplayer.org/functional.{ext}" },
                        "530p",
                        "800p"
                        ]
                    },
                    sources: [
                                { 
                                  type: "application/x-mpegurl",
                                  //src: "http://localhost/videosrc/leela.m3u8"
                                  src: "https://dn9p8lkvkvcok.cloudfront.net/"+video_files
                                }
                              ],
                              rtmp: "rtmp://s3b78u0kbtx79q.cloudfront.net/cfx/st",
                    },

                    
                //],

                embed: false
                                    

            };

        }
        return (<div key="an_video" className="announcement">
            <div key={Date.now()} className="border-box">
                    {/* <Flowplayer playlist={playlist} trackData={trackData} /> */}

                    <video width="320" height="240" controls>
                    <source src={`${Config.rootDomainUrl}admin/announcement_video_files/${video_files}`} type="video/mp4" />
                    Your browser does not support the video tag.
                    </video>

                </div>                  
                <div key="v_text" dangerouslySetInnerHTML={{ __html:text}} />                
            </div>);
    }
    audio_frame(audio_files, text) {
        let control_style = {
            position: 'relative'
        };
        return (<div key="an_audio" className="announcement">
        <audio style={control_style} controls controlsList="nodownload">
          <source src={`${Config.rootDomainUrl}admin/announcement_audio_files/${audio_files}`} type="audio/mpeg" width="400" height="50"/>
        </audio>
        <div key="an_text" dangerouslySetInnerHTML={{ __html:text}} />
      </div>);
    }
    image_frame(image_files, image_description, text_message) {
        return (<div key="an_image" className="announcement">
        <div className="announcementtext">
          <img src={Config.rootDomainUrl+"admin/announcement_image_files/"+image_files} alt="" className="announceimg" border="0" />
        </div>
        <div dangerouslySetInnerHTML={{ __html:image_description}} />
      </div>);
    }
    text_frame(text_files) { 
        return (<div key="an_text" className="announcement announcement-nw">
         <div dangerouslySetInnerHTML={{ __html:text_files}} ></div>
          </div>);
    }
    onsubmit() {
        const { data } = this.props;
        let cant = this.state.anouncet;
        if(cant.audio_file!='' || cant.video_file!=''){
            let message ='Finished watching/listening? '
            message = (cant.audio_file!='' && cant.video_file=='') ? 'Finished listening? ':message;
            message = (cant.audio_file=='' && cant.video_file!='') ? 'Finished watching? ':message;
            
            let rsfbacl = (cant.Isvisible!='1') ? 'You will not be able to come back to it later.':''
            window.swal({
                //title: 'View!',
                text: message + rsfbacl,
               // type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#14a430',
                cancelButtonColor: '#0082c9',
                animation: false,
                confirmButtonText: 'Ok'
            }).then((result) => {
                if(result){  this.saveallfn(); }
            });
        } else {
            this.saveallfn();
        }
    }

    saveallfn(){
        const { data } = this.props;
        Common.reactLoader("show", "Please wait...");        
        fetch(Config.domainUrl + 'anouncement/saveall', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify({
                compseq_id: data.compseq_id,
                lroom_id: data.learning_room_id,
                divider_id: data.divider_id,
                learner_id: User.UserId(),
                dlr_id: data.dlr_id,
            })
        }).then((response) => response.json()).then((responseJson) => {
            this.props.getLearningRoom();
            Common.scrollToTop();
            if (responseJson.isCompletedFully) {
                this.goToThanksPage();
            } else {
                this.props.switchback(responseJson.result);
            }
            Common.composcroll();
            setTimeout(() => { Common.reactLoader("hide") }, 900);
        });
    }

    goToThanksPage() {
        const { data } = this.props;
        this.props.returnthanks({
            "status": "completed",
            "learning_room_id": data.learning_room_id,
            "compseq_id": data.compseq_id,
            "divider_id": data.divider_id,
            "dlr_id": data.dlr_id,
            "learner_id": data.learner_id,
            "is_ag": data.is_ag,
            "id": data.id,
            "compo_type": "thanks",
            "look_before": data.compseq_id,
            "flowresult": true
        });
    }
    sortinglists(type) {
        let data = this.state.anouncet;
        let retval = '';
        switch (type) {
            case 'pdf':
                if (data.pdf_file != null && data.pdf_file != '') {
                    let pdfpath = Config.rootDomainUrl + 'admin/announcement_pdf_files/' + data.pdf_file;
                    retval = <Pdfview key={`pdf_view_0`} pdfpath={pdfpath} title="PDF"/>; //this.pdf_frame(data.pdf_file);
                }
                break;
            case 'video':
                if ((data.video_file != null && data.video_file != '') || (data.video_filename!= null && data.video_filename != '')) {
                    if(data.video_filename!='')
                    {
                        retval = this.video_frame(data.video_filename, data.video_description);
                    }
                    else if(data.video_file!='')
                    {
                        retval = this.video_frame(data.video_file, data.video_description);
                    }
                }
                break;
            case 'audio':
                if (data.audio_file != null && data.audio_file != '') {
                    retval = this.audio_frame(data.audio_file, data.audio_description);
                }
                break;
            case 'image':
                if (data.image_file != null && data.image_file != '') {
                    retval = this.image_frame(data.image_file, data.image_description, data.message);
                }
                break;
            case 'text':
                if (data.message != null && data.message != '') {
                    retval = this.text_frame(data.message);
                }
                break;
        }
        return retval;
    }
    submitbuttons() {
        if (this.compeletestatus == 'completed') {
            return <div id="Active" className="button annonbtn gotobtn">
                <input name="btnsubmit" value="Continue" alt="Continue" title="Continue" type="button" onClick={e=>this.onsubmit()} />
            </div>
        } else {
            return <div id="Active" className="button annonbtn gotobtn">
                <input name="btnsubmit" value="Go to next page" alt="Go to next page" title="Go to next page" type="button" onClick={e=>this.onsubmit()}/>
            </div>
        }
    }
    
    render() {
        let data = this.state.anouncet;
        let asorting = this.state.anouncesorting;
        return (<div className="main-inner">
            <div className="border-box">
            
                <div className={data.base_line?"title-box":"title-box tit-new"}>
                    <div title="Annoncement" className="an_active_button"></div>
                    <h6>{data.anouncement_name?data.anouncement_name:''}</h6>
                    <span>{data.base_line?data.base_line:''}</span>
                </div>
                <section className="scrol" id="smana-scroll-inner">
                    <section className="viewport">
                        <section className="overview">
                        <div className="inner-content">
                                {asorting.map((val,key)=>{return this.sortinglists(val);})}
                                
                                {this.submitbuttons()}
                                {/* <Previous_Next learnerid={this.state.learner_id} lrroomid={this.state.learning_room_id} currentcomponent={'an_'+data.anouncement_id_pk}/> */}
                            </div>
                        </section>
                    </section>
                </section>
            </div>
        </div>);
    }
}

  
function mapDispatchToProps(dispatch) {    
    return  bindActionCreators({getLearningRoom}, dispatch);   
}
  
export default connect(null,mapDispatchToProps)(Anouncement);



// WEBPACK FOOTER //
// ./src/lr_dlr_components/Anouncement.js